var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.3223 8V16H11.873V9.41016H11.8262L9.95508 10.6055V9.27734L11.9434 8H13.3223Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }